import { render, staticRenderFns } from "./ProductsFilters.vue?vue&type=template&id=fdca3838&scoped=true&%3Akey=%24route.fullPath"
import script from "./ProductsFilters.vue?vue&type=script&lang=js"
export * from "./ProductsFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilters.vue?vue&type=style&index=0&id=fdca3838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdca3838",
  null
  
)

export default component.exports